import type { ReactNode } from 'react'
import { CheckCircle2, XCircle, Info, X } from 'lucide-react'
import { useToastStore, type ToastType } from '@/store/useToastStore'
import { cn } from '@/shared/utils'

const STYLES: Record<ToastType, { bar: string; icon: ReactNode }> = {
  success: { bar: 'border-l-green-500', icon: <CheckCircle2 size={18} className="text-green-500" /> },
  error:   { bar: 'border-l-red-500',   icon: <XCircle size={18} className="text-red-500" /> },
  info:    { bar: 'border-l-brand-500',  icon: <Info size={18} className="text-brand-500" /> },
}

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  const remove = useToastStore((s) => s.remove)

  if (toasts.length === 0) return null

  return (
    <div className="fixed top-4 right-4 z-[200] flex flex-col gap-2 w-[340px] max-w-[calc(100vw-2rem)]">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="alert"
          className={cn(
            'flex items-start gap-2.5 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 border-l-4 px-4 py-3 transition-all',
            STYLES[t.type].bar
          )}
        >
          <span className="flex-shrink-0 pt-0.5">{STYLES[t.type].icon}</span>
          <p className="flex-1 text-sm font-medium text-gray-700 dark:text-gray-200 leading-snug">{t.message}</p>
          <button onClick={() => remove(t.id)} className="flex-shrink-0 text-gray-300 hover:text-gray-500">
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  )
}
